import { sitInstance } from '../api/instances';
import { toastSuccess, toastError } from '../const/toast';

export const fetchStudyFlags = (params = {}) => {
  const { withDiscarded = true, sliceType = 'all', sliceId } = params;

  const queryParams = {
    with_discarded: withDiscarded,
    slice_type: sliceType,
  };

  if (sliceId && (sliceType === 'organization' || sliceType === 'division')) {
    queryParams.slice_id = sliceId;
  }

  return sitInstance.get('/study_flags', {
    params: queryParams,
  })
    .catch((error) => {
      console.error('Error fetching study flags:', error);
      console.error('Request URL:', error.config?.url);
      console.error('Response:', error.response);
      throw error;
    });
};

export const fetchStudyFlag = (id) => {
  return sitInstance.get(`/study_flags/${id}`);
};

export const createStudyFlag = (payload) => {
  return sitInstance.post('/study_flags', { study_flag: payload })
    .then(() => toastSuccess('Study flag created'))
    .catch(() => toastError('Error creating study flag'));
};

export const updateStudyFlag = (id, payload) => {
  return sitInstance.put(`/study_flags/${id}`, { study_flag: payload })
    .then(() => toastSuccess('Study flag updated'))
    .catch(() => toastError('Error updating study flag'));
};

export const deleteStudyFlag = (id) => {
  return sitInstance.delete(`/study_flags/${id}`)
    .then(() => toastSuccess('Study flag disabled'))
    .catch(() => toastError('Error disabling study flag'));
};

export const reactivateStudyFlag = (id) => {
  return sitInstance.patch(`/study_flags/${id}/reactivate`)
    .then(() => toastSuccess('Study flag reactivated'))
    .catch(() => toastError('Error reactivating study flag'));
};
